const uniqueSectionParentPairs = {
  Needs: "Feature Needs with Rationale",
  Usecases: "Use cases",
  Requirements: "Feature Requirements with Rationale",
  User_stories: "User Stories",
  test_case_steps: "Test Case Steps",
  Expected_results: "Acceptance Criteria & Expected Results",
  parent_generation: "User System Requirements",
  Traceability: "End to End Traceability",
};

export const downloadFile = async (htmlCode, type, fileName) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/download_version`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ htmlcode: htmlCode, download_file_type: type }),
      }
    );

    if (response.ok) {
      if (type == "text") {
        type = "txt";
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}.${type}`);

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
    } else {
      console.error("Failed to download file:", response.statusText);
    }
  } catch (error) {
    console.error("Error submitting HTML:", error);
  }
};
export const downloadGcsFile = async (gcsUrl, fileType, file_name) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await fetch(
      `${
        import.meta.env.VITE_API_URL
      }/download-file?gcs_path=${gcsUrl}&download_file_type=${fileType}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      if (fileType == "text") {
        fileType = "txt";
      }

      let filename = file_name + "." + fileType;

      const blob = await response.blob();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}`);

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
    } else {
      console.error("Failed to download file:", response.statusText);
    }
  } catch (error) {
    console.error("Error submitting HTML:", error);
  }
};
